import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconList } from '@nazka/nazka.mapframe.components';

import { FLASH_FLOOD_LEGEND_ITEMS, LEGEND_ITEMS } from './legend.constants';
import { setLegendSwitchSelection } from './legend.redux.action';

import './legend.styl'

function Legend({ forPrint, customLegendSelection }) {
  const tempSwitchSelection = useSelector(state => state.legend.legendSelection)
  const switchSelection = customLegendSelection ?? tempSwitchSelection
  const currentSelectedDamageLayer = useSelector(state => state.layerSelector.currentSelectedDamageLayer)
  const showBuildingDamages = useSelector(state => state.layerSelector.showBuildingDamages);
  const isCreatingNewDamageLayer = useSelector(state => state.newDamageLayer.isCreatingNewDamageLayer);
  const userSelectedMode = useSelector(state => state.maplibreMap.userSelectedMode);
  const dispatch = useDispatch()

  const { maxTotalDamage, minTotalDamage } = currentSelectedDamageLayer || {};

  useEffect(() => {
    if (maxTotalDamage === minTotalDamage && switchSelection === 'cost') {
      dispatch(setLegendSwitchSelection('classes'));
    }
  }, [dispatch, maxTotalDamage, minTotalDamage, switchSelection]);

  const handleSwitcherToggle = (selection) => {
    dispatch(setLegendSwitchSelection(selection))
  }

  if (!showBuildingDamages || isCreatingNewDamageLayer) {
    return null;
  }

  return (
    <div className="legend">
      {!forPrint && (
        <div className="legend__switch">
          <button
            type="button"
            className={`legend__switch__button${switchSelection === 'classes' ? ' legend__switch__button--active' : ''}`}
            onClick={() => handleSwitcherToggle('classes')}
          >
            Classes
          </button>
          <button
            type="button"
            className={`legend__switch__button${switchSelection === 'cost' ? ' legend__switch__button--active' : ''}`}
            onClick={() => handleSwitcherToggle('cost')}
            disabled={minTotalDamage === maxTotalDamage}
          >
            { userSelectedMode === 'River flood' ? 'Cost' : 'Continuous'} 
          </button>
        </div>
      )}
      
      {switchSelection === 'classes' ? (
        <IconList
          className="legend__classes"
          items={userSelectedMode === 'River flood' ? LEGEND_ITEMS : FLASH_FLOOD_LEGEND_ITEMS}
          css={{
            display: 'flex',
            gap: '5px',
            padding: '0 6px',
            li: {
              fontSize: '12px',
              '> div:first-of-type': {
                paddingRight: '5px',
              },
            },
          }}
        />
      ) : (
        <div className="legend__gradient">
          <div
            className={`legend__gradient__bar 
              ${userSelectedMode === 'Flash flood'
              ? 'legend__gradient__bar--flash'
              : 'legend__gradient__bar'}`}
          />
          <div className="legend__gradient__labels">
            <span>
              { userSelectedMode === 'River flood' && '€'}
              {Math.round(minTotalDamage)}
              { userSelectedMode === 'Flash flood' && 'mm'}
            </span>
            <span>
              { userSelectedMode === 'River flood' && '€'}
              {Math.round(maxTotalDamage)}
              { userSelectedMode === 'Flash flood' && 'mm'}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export default Legend